function IsEmptyString(str) {
  if (str == "undefined" || !str || !/[^\s]/.test(str)) {
    return true;
  } else {
    return false; //不为空
  }
}
function validateEmail(email) {
  const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z]{2,6}$/;
  return reg.test(email);
}

export { IsEmptyString, validateEmail };
